import { cva } from "class-variance-authority";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

const logoVariants = cva("font-mono font-bold tracking-tight", {
  variants: {
    size: {
      sm: "text-base",
      md: "text-xl",
      lg: "text-3xl",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export interface LogoMarkProps {
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
  href?: string;
}

export const LogoMark = ({ size = "md", onClick, href = "/" }: LogoMarkProps) => {
  const { t } = useTranslation();
  const content = (
    <>
      &lt;Kevin.<span className="text-accent">Lopez</span>/&gt;
    </>
  );
  const ariaLabel = t("nav.home", { defaultValue: "Home" });
  const className = `${logoVariants({ size })} text-primary`;

  if (href) {
    return (
      <Link to={href} onClick={onClick} aria-label={ariaLabel} className={className}>
        {content}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} aria-label={ariaLabel} className={className}>
        {content}
      </button>
    );
  }

  return (
    <span aria-label={ariaLabel} className={className}>
      {content}
    </span>
  );
};
